import React from 'react';
import { Size, getSize } from './utils';

export type IconType = 'filled' | 'stroke';

interface Props {
    type: IconType;
    color: string;
    size?: Size;
}

export const InfoIcon: React.FC<Props> = ({ color, size = 's', type }) => {
    const sizePx = getSize(size);

    switch (type) {
        case 'filled':
            return (
                <svg width={sizePx} height={sizePx} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.696-3.534c.63 0 1.332-.288 2.196-1.458l.911-1.22a.334.334 0 00-.074-.472.38.38 0 00-.505.06l-1.475 1.679a.241.241 0 01-.279.061.211.211 0 01-.12-.244l1.858-7.446a.499.499 0 00-.575-.613l-3.35.613a.35.35 0 00-.276.258l-.086.334a.25.25 0 00.243.312h1.73l-1.476 5.922c-.054.234-.144.63-.144.918 0 .666.396 1.296 1.422 1.296zm1.83-10.536c.702 0 1.242-.414 1.386-1.044.036-.144.054-.306.054-.414 0-.504-.396-.972-1.134-.972-.702 0-1.242.414-1.386 1.044a1.868 1.868 0 00-.054.414c0 .504.396.972 1.134.972z"
                        fill={color}
                    />
                </svg>
            );
        case 'stroke':
            return (
                <svg width={sizePx} height={sizePx} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 8.003a8 8 0 1016 0 8 8 0 00-16 0zm14 0a6 6 0 11-12.001 0 6 6 0 0112.001 0zM6.86 11.03c0-.672.492-1.14 1.14-1.14.648 0 1.14.468 1.14 1.14 0 .672-.492 1.14-1.14 1.14-.648 0-1.14-.468-1.14-1.14zM7.58 4h.842a.75.75 0 01.747.825l-.373 3.724a.5.5 0 01-.497.45h-.596a.5.5 0 01-.497-.45l-.373-3.724A.75.75 0 017.58 4z"
                        fill={color}
                    />
                </svg>
            );
    }
};
